import { BE_USER_FEATURES } from 'src/lib/featureFlags';

import useCurrentUser from './useCurrentUser';

export const useIsSuperAdminUser = () => {
  const user = useCurrentUser();
  return (user?.featureFlags ?? []).includes(BE_USER_FEATURES.superAdminUser);
};
